const chapter = {
  id: 'environmental-issues',
  slug: 'environmental-issues',
  subject: 'biology',
  subjectLabel: 'Biology',
  exam: 'NEET',
  title: {
    english: 'Environmental Issues',
        hindi: 'पर्यावरणीय मुद्दे',
  },
  estReadMinutes: 50,
  difficulty: {
    english: 'Easy',
        hindi: 'आसान',
  },
  weightage: {
    english: '2-3 questions in NEET',
        hindi: 'NEET में 2-3 प्रश्न',
  },
  syllabusTags: ['Ecology', 'NEET', 'Class-12'],
  sections: [
    {
      id: 'air-pollution',
      title: {
        english: 'Air Pollution & Its Control',
        hindi: 'वायु प्रदूषण और उसका नियंत्रण',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Pollution = undesirable change in physical, chemical or biological characteristics of air, water, soil. **Pollutants** = agents that bring this change.',
        hindi: 'Pollution = undesirable change in physical, हवा, पानी, मिट्टी की रासायनिक या जैविक विशेषताएं। **प्रदूषक** = ऐसे एजेंट जो यह परिवर्तन लाते हैं।',
            },
            {
              english: '**Environment (Protection) Act 1986** — passed to protect & improve environmental quality.',
        hindi: '**पर्यावरण (संरक्षण) अधिनियम 1986** - पर्यावरण की गुणवत्ता की रक्षा और सुधार के लिए पारित किया गया।',
            },
            {
              english: 'Air pollutants harm all organisms — ↓ growth + ↓ yield of crops, premature death.',
        hindi: 'वायु प्रदूषक सभी जीवों को नुकसान पहुंचाते हैं - ↓ विकास + ↓ फसलों की उपज, अकाल मृत्यु।',
            },
            {
              english: 'Major pollutants — CO, SO₂, NO₂, hydrocarbons, **Suspended Particulate Matter (SPM)**.',
        hindi: 'प्रमुख प्रदूषक - CO, SO₂, NO₂, हाइड्रोकार्बन, **सस्पेंडेड पार्टिकुलेट मैटर (SPM)**।',
            },
            {
              english: '**Electrostatic Precipitator (ESP)** — removes > **99 % of particulate matter** in thermal-plant chimneys. Electrode wires kept at thousands of volts → produce **corona** → electrons → attach to dust particles → giving them net negative charge → collecting plates (grounded, +ve) attract them; air velocity inside ESP must be slow enough for particles to fall.',
        hindi: '**इलेक्ट्रोस्टैटिक प्रीसिपिटेटर (ईएसपी)** - थर्मल-प्लांट चिमनी में > **99% पार्टिकुलेट मैटर** को हटा देता है। हजारों वोल्ट पर रखे गए इलेक्ट्रोड तार → **कोरोना** उत्पन्न करते हैं → इलेक्ट्रॉन → धूल के कणों से जुड़ते हैं → उन्हें शुद्ध नकारात्मक चार्ज देते हैं → एकत्रित प्लेटें (ग्राउंडेड, +वे) उन्हें आकर्षित करती हैं; ईएसपी के अंदर हवा का वेग इतना धीमा होना चाहिए कि कण गिर सकें।',
            },
            {
              english: '**Scrubber** — exhaust gases passed through spray of water or lime → removes SO₂ + other gases.',
        hindi: '**स्क्रबर** - पानी या चूने के स्प्रे के माध्यम से पारित निकास गैसें → SO₂ + अन्य गैसों को हटा देती हैं।',
            },
            {
              english: '**Catalytic converters** in vehicles — Pt-Pd-Rh as catalysts; convert unburnt hydrocarbons → CO₂ + H₂O; CO + NO → CO₂ + N₂. Vehicles must use **unleaded petrol** (lead inactivates catalyst).',
        hindi: '**वाहनों में कैटेलिटिक कन्वर्टर्स** - उत्प्रेरक के रूप में पीटी-पीडी-आरएच; बिना जले हाइड्रोकार्बन को परिवर्तित करें → CO₂ + H₂O; CO + NO → CO₂ + N₂. वाहनों को **अनलेडेड पेट्रोल** (सीसा निष्क्रिय उत्प्रेरक) का उपयोग करना चाहिए।',
            },
            {
              english: '**Indian CNG initiative (Delhi)** — all public transport (buses) switched to CNG by Dec 2002 → reduced air pollution drastically. Better than petrol/diesel: burns most efficiently (no unburnt residue), cheap, can\'t be siphoned off, less adulterated.',
        hindi: '**भारतीय सीएनजी पहल (दिल्ली)** - दिसंबर 2002 तक सभी सार्वजनिक परिवहन (बसें) सीएनजी में बदल गईं → वायु प्रदूषण में भारी कमी आई। petrol/diesel से बेहतर: सबसे अधिक कुशलता से जलता है (कोई अधजला अवशेष नहीं), सस्ता, छीना नहीं जा सकता, कम मिलावटी।',
            },
            {
              english: '**National Air Quality Index (AQI)** introduced under "Swachh Bharat Abhiyan" (2014) → 8 pollutants tracked.',
        hindi: '**राष्ट्रीय वायु गुणवत्ता सूचकांक (एक्यूआई)** "स्वच्छ भारत अभियान" (2014) के तहत पेश किया गया → 8 प्रदूषकों पर नज़र रखी गई।',
            },
          ],
        },
      ],
    },
    {
      id: 'noise-pollution',
      title: {
        english: 'Noise Pollution',
        hindi: 'ध्वनि प्रदूषण',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Sound > 80 dB → noise pollution. Brief exposure to extremely high sound (> 150 dB, jet/rocket take-off) → permanent damage to ear drum.',
        hindi: 'ध्वनि > 80 डीबी → ध्वनि प्रदूषण। अत्यधिक उच्च ध्वनि का संक्षिप्त जोखिम (> 150 डीबी, jet/rocket टेक-ऑफ) → कान के पर्दे को स्थायी क्षति।',
            },
            {
              english: 'Effects: sleeplessness, ↑ heart rate, breathing problems.',
        hindi: 'प्रभाव: नींद न आना, ↑ हृदय गति, सांस लेने में समस्या।',
            },
            {
              english: 'Control: sound-absorbent material in industrial & home appliances, planting trees along roads, strict legal control of horn use & loudspeakers.',
        hindi: 'नियंत्रण: औद्योगिक और घरेलू उपकरणों में ध्वनि-अवशोषक सामग्री, सड़कों के किनारे पेड़ लगाना, हॉर्न और लाउडस्पीकर के उपयोग पर सख्त कानूनी नियंत्रण।',
            },
          ],
        },
      ],
    },
    {
      id: 'water-pollution',
      title: {
        english: 'Water Pollution & Its Control',
        hindi: 'जल प्रदूषण और उसका नियंत्रण',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**Water (Prevention & Control of Pollution) Act 1974** — to safeguard water resources.',
        hindi: '**जल (प्रदूषण निवारण एवं नियंत्रण) अधिनियम 1974**- जल संसाधनों की सुरक्षा के लिए।',
            },
            {
              english: '**Domestic sewage** — > 99 % water + < 1 % suspended solids, dissolved organic + inorganic.',
        hindi: '**घरेलू सीवेज** - > 99% पानी + <1% निलंबित ठोस, घुले हुए कार्बनिक + अकार्बनिक।',
            },
            {
              english: '**BOD (Biochemical Oxygen Demand)** — O₂ required by bacteria to break down organic matter in 1 L of water. **Higher BOD = higher pollution**.',
        hindi: '**बीओडी (बायोकेमिकल ऑक्सीजन डिमांड)** - 1 लीटर पानी में कार्बनिक पदार्थ को तोड़ने के लिए बैक्टीरिया को O₂ की आवश्यकता होती है। **उच्चतर BOD = higher pollution**।',
            },
            {
              english: '**Algal bloom** — accelerated growth of planktonic (free-floating) algae from nutrient enrichment of water → toxic + ↓ DO + bad smell + colours of water (red tide etc.).',
        hindi: '**शैवाल प्रस्फुटन** - पानी के पोषक तत्व संवर्धन → विषाक्त + ↓ डीओ + खराब गंध + पानी के रंग (लाल ज्वार आदि) से प्लवक (मुक्त-तैरने वाले) शैवाल की त्वरित वृद्धि।',
            },
            {
              english: '**Eutrophication** — natural ageing of lake by nutrient enrichment. Accelerated by sewage + agricultural runoff (N, P) → **cultural eutrophication**.',
        hindi: '**यूट्रोफिकेशन** - पोषक तत्वों के संवर्धन द्वारा झील की प्राकृतिक उम्र बढ़ना। सीवेज + कृषि अपवाह (एन, पी) → **सांस्कृतिक यूट्रोफिकेशन** द्वारा त्वरित।',
            },
            {
              english: '**Biomagnification** — increase in concentration of toxic substance at successive trophic levels (substance not metabolised/excreted).',
        hindi: '**जैवआवर्धन** - क्रमिक पोषी स्तरों पर विषाक्त पदार्थ की सांद्रता में वृद्धि (पदार्थ metabolised/excreted नहीं)।',
            },
            {
              english: '• Classic example: **DDT in Long Island estuary** — water 0.003 ppb → zooplankton 0.04 ppm → small fish 0.5 ppm → large fish 2 ppm → **fish-eating birds 25 ppm**. High DDT → ↓ Ca deposition → eggshells thin & break.',
        hindi: '• उत्कृष्ट उदाहरण: **लॉन्ग आइलैंड मुहाना में डीडीटी** - पानी 0.003 पीपीबी → ज़ोप्लांकटन 0.04 पीपीएम → छोटी मछली 0.5 पीपीएम → बड़ी मछली 2 पीपीएम → **मछली खाने वाले पक्षी 25 पीपीएम**। उच्च डीडीटी → ↓ सीए जमाव → अंडे के छिलके पतले और टूटते हैं।',
            },
            {
              english: '**Mercury (Hg) — Minamata disease** in Japan (1932-1968) — methylmercury from chemical plant → biomagnified in fish → severe neurological damage in humans.',
        hindi: '**पारा (एचजी) - जापान में मिनामाटा रोग** (1932-1968) - रासायनिक संयंत्र से मिथाइलमेरकरी → मछली में बायोमैग्नीफाइड → मनुष्यों में गंभीर तंत्रिका संबंधी क्षति।',
            },
            {
              english: '**Mineral oil pollution** — Exxon Valdez tanker (Alaska, 1989) → ~ 11 million gallons spilt; killed thousands of birds, fish, mammals.',
        hindi: '**खनिज तेल प्रदूषण** - एक्सॉन वाल्डेज़ टैंकर (अलास्का, 1989) → ~11 मिलियन गैलन रिसाव; हजारों पक्षियों, मछलियों, स्तनधारियों को मार डाला।',
            },
            {
              english: '**Integrated Waste-Water Treatment** — Arcata (California) — sewage cleaned by conventional sedimentation + filtering + chlorination + then through 60 hectares of marshes → algae, bacteria, fungi, plants neutralise & absorb pollutants → also bird sanctuary.',
        hindi: '**एकीकृत अपशिष्ट-जल उपचार** - अर्काटा (कैलिफ़ोर्निया) - सीवेज को पारंपरिक अवसादन + फ़िल्टरिंग + क्लोरीनीकरण + फिर 60 हेक्टेयर दलदल के माध्यम से साफ किया जाता है → शैवाल, बैक्टीरिया, कवक, पौधे प्रदूषकों को बेअसर और अवशोषित करते हैं → पक्षी अभयारण्य भी।',
            },
          ],
        },
      ],
    },
    {
      id: 'solid-radioactive',
      title: {
        english: 'Solid Wastes & Radioactive Wastes',
        hindi: 'ठोस अपशिष्ट और रेडियोधर्मी अपशिष्ट',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Solid wastes — everything that goes out in trash. Three categories:',
        hindi: 'ठोस अपशिष्ट - वह सब कुछ जो कूड़े में जाता है। तीन श्रेणियां:',
            },
            {
              english: '• **Bio-degradable** — burned / composted (organic kitchen, paper).',
        hindi: '• **जैव-निम्नीकरणीय** - जला हुआ / खाद बनाया हुआ (जैविक रसोई, कागज)।',
            },
            {
              english: '• **Recyclable** — recycled (plastic, glass, metal scrap).',
        hindi: '• **पुनर्चक्रणीय** - पुनर्चक्रित (प्लास्टिक, कांच, धातु स्क्रैप)।',
            },
            {
              english: '• **Non-biodegradable** — landfills.',
        hindi: '• **गैर-बायोडिग्रेडेबल** - लैंडफिल। **अस्पताल के अपशिष्ट** - ड्रेसिंग, सीरिंज, प्रयुक्त कपास, शरीर के तरल पदार्थ → **भस्मक** आवश्यक हैं।',
            },
            {
              english: '**Hospital wastes** — dressings, syringes, used cotton, body fluids → **incinerators** are essential.',
        hindi: '**अस्पताल के अपशिष्ट** - ड्रेसिंग, सीरिंज, प्रयुक्त कपास, शरीर के तरल पदार्थ → **भस्मक** आवश्यक हैं।',
            },
            {
              english: '**E-waste** — irreparable computers, electronic goods. Re-cycling is the only solution; in developed countries ↑ but unfortunately exported to developing countries → women & children expose themselves to toxic substances during recovery of metals.',
        hindi: '**ई-कचरा** - अपूरणीय कंप्यूटर, इलेक्ट्रॉनिक सामान। पुनर्चक्रण ही एकमात्र समाधान है; विकसित देशों में ↑ लेकिन दुर्भाग्य से विकासशील देशों को निर्यात किया जाता है → महिलाएं और बच्चे धातुओं की पुनर्प्राप्ति के दौरान खुद को विषाक्त पदार्थों के संपर्क में लाते हैं।',
            },
            {
              english: '**Indian initiative**: **Ahmedabad municipal authority + Mr Ramesh Babu** + Eco-club → 130 km of plastic-tar mixed road in Bangalore by Mr **Ahmed Khan** (since 2002) — uses ground plastic + bitumen → road is more durable + waterproof (also solves litter problem).',
        hindi: '**भारतीय पहल**: **अहमदाबाद नगरपालिका प्राधिकरण + श्री रमेश बाबू** + इको-क्लब → श्री **अहमद खान** द्वारा बैंगलोर में 130 किमी प्लास्टिक-टार मिश्रित सड़क (2002 से) - ग्राउंड प्लास्टिक + बिटुमेन का उपयोग करता है → सड़क अधिक टिकाऊ + जलरोधक है (कूड़े की समस्या भी हल करती है)। **रेडियोधर्मी अपशिष्ट** - **परमाणु ऊर्जा संयंत्रों, यूरेनियम खनन, एक्स-रे, परमाणु हथियार परीक्षणों** द्वारा उत्पन्न।',
            },
            {
              english: '**Radioactive wastes** — generated by **nuclear power plants, uranium mining, X-ray, nuclear weapon tests**.',
        hindi: '**रेडियोधर्मी अपशिष्ट** - **परमाणु ऊर्जा संयंत्रों, यूरेनियम खनन, एक्स-रे, परमाणु हथियार परीक्षणों** द्वारा उत्पन्न।',
            },
            {
              english: '• Low doses → cancer (mutations).',
        hindi: '• कम खुराक → कैंसर (उत्परिवर्तन)।',
            },
            {
              english: '• High dose → death.',
        hindi: '• उच्च खुराक → मृत्यु।',
            },
            {
              english: '• Storage — pre-treated to acceptable form → suitably shielded containers → buried under rocks **~500 m deep** below earth\'s surface.',
        hindi: '• भंडारण - स्वीकार्य रूप में पूर्व-उपचारित → उपयुक्त रूप से संरक्षित कंटेनर → पृथ्वी की सतह के नीचे **~500 मीटर गहराई** चट्टानों के नीचे दबे हुए।',
            },
          ],
        },
      ],
    },
    {
      id: 'greenhouse-ozone',
      title: {
        english: 'Global Warming & Ozone Depletion',
        hindi: 'वैश्विक तापमान वृद्धि और ओज़ोन क्षरण',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**Greenhouse effect** — heating of Earth\'s surface due to retention of long-wave (infra-red) radiation by atmospheric gases (mainly CO₂, water vapour, CH₄, N₂O, CFCs).',
        hindi: '**ग्रीनहाउस प्रभाव** - वायुमंडलीय गैसों (मुख्य रूप से CO₂, जल वाष्प, CH₄, N₂O, CFCs) द्वारा लंबी-तरंग (इन्फ्रा-रेड) विकिरण को बनाए रखने के कारण पृथ्वी की सतह का गर्म होना।',
            },
            {
              english: 'Contributions to greenhouse warming: **CO₂ 60 %, CH₄ 20 %, CFCs 14 %, N₂O 6 %**.',
        hindi: 'ग्रीनहाउस वार्मिंग में योगदान: **CO₂ 60%, CH₄ 20%, CFCs 14%, N₂O 6%**।',
            },
            {
              english: 'Mean global T has risen ~ **0.6 °C in last century**; could rise 1.4-5.8 °C by 2100 → **glacial melts, sea-level rise (40-120 cm)**, drowning coastal areas.',
        hindi: 'औसत वैश्विक तापमान पिछली सदी में ~ **0.6 डिग्री सेल्सियस बढ़ गया है**; 2100 तक 1.4-5.8 डिग्री सेल्सियस बढ़ सकता है → **हिमनदों का पिघलना, समुद्र के स्तर में वृद्धि (40-120 सेमी)**, तटीय क्षेत्रों का डूबना।',
            },
            {
              english: 'Control: cut fossil fuel use, ↑ vegetation cover, slow growth of human population, international protocols (**Kyoto, Montreal, Paris**).',
        hindi: 'नियंत्रण: जीवाश्म ईंधन के उपयोग में कटौती, ↑ वनस्पति आवरण, मानव आबादी की धीमी वृद्धि, अंतर्राष्ट्रीय प्रोटोकॉल (**क्योटो, मॉन्ट्रियल, पेरिस**)।',
            },
            {
              english: '**Ozone depletion**: O₃ in stratosphere (15-50 km, "ozone shield") absorbs harmful UV-B; thickness in **Dobson units (DU)**.',
        hindi: '**ओजोन रिक्तीकरण**: समताप मंडल में O₃ (15-50 किमी, "ओजोन ढाल") हानिकारक UV-B को अवशोषित करता है; **डॉब्सन इकाइयों (डीयू)** में मोटाई।',
            },
            {
              english: 'Cause = **CFCs (chlorofluorocarbons)** → release Cl atoms in stratosphere → 1 Cl atom destroys ~ **10⁵ O₃** molecules.',
        hindi: 'कारण = **सीएफसी (क्लोरोफ्लोरोकार्बन)** → समताप मंडल में सीएल परमाणुओं को छोड़ता है → 1 सीएल परमाणु ~ **10⁵O₃** अणुओं को नष्ट कर देता है।',
            },
            {
              english: '**Ozone hole** over Antarctica — discovered in 1980s.',
        hindi: '**अंटार्कटिका के ऊपर ओजोन छिद्र** - 1980 के दशक में खोजा गया।',
            },
            {
              english: 'UV-B effects: damages DNA, mutation, ageing of skin, **damage to eye cornea (snow-blindness, cataract)**, skin cancer (basal-cell, squamous).',
        hindi: 'यूवी-बी प्रभाव: डीएनए को नुकसान, उत्परिवर्तन, त्वचा की उम्र बढ़ना, **आंखों के कॉर्निया को नुकसान (स्नो-ब्लाइंडनेस, मोतियाबिंद)**, त्वचा कैंसर (बेसल-सेल, स्क्वैमस)।',
            },
            {
              english: 'Control — **Montreal Protocol (1987)** signed to control CFC emissions globally.',
        hindi: 'नियंत्रण - विश्व स्तर पर सीएफसी उत्सर्जन को नियंत्रित करने के लिए **मॉन्ट्रियल प्रोटोकॉल (1987)** पर हस्ताक्षर किए गए।',
            },
          ],
        },
      ],
    },
    {
      id: 'degradation-deforestation',
      title: {
        english: 'Degradation by Improper Resource Use & Deforestation',
        hindi: 'अनुचित संसाधन उपयोग और वनोन्मूलन से क्षरण',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**Soil erosion + desertification** — over-cultivation, unrestricted grazing, deforestation, poor irrigation → loss of fertile top soil. Indian estimate: ~ 12 % of land = wasteland.',
        hindi: '**मिट्टी का कटाव + मरुस्थलीकरण** - अत्यधिक खेती, अप्रतिबंधित चराई, वनों की कटाई, खराब सिंचाई → उपजाऊ ऊपरी मिट्टी का नुकसान। भारतीय अनुमान: land = wasteland का ~12%।',
            },
            {
              english: '**Waterlogging + soil salinity** — excessive irrigation → water table rises → roots starve of O₂; salts brought to surface → crusted top soil.',
        hindi: '**जल भराव + मिट्टी की लवणता** - अत्यधिक सिंचाई → जल स्तर बढ़ना → जड़ें O₂ की भूखी रहती हैं; नमक को सतह पर लाया गया → परतदार ऊपरी मिट्टी।',
            },
            {
              english: '**Deforestation** — conversion of forested area into non-forested. India\'s forest cover at start of 20th century ~ 30 %; by century end < 19.4 % (against National Forest Policy target = 33 %).',
        hindi: '**वनों की कटाई** - वनाच्छादित क्षेत्र को गैर-वनाच्छादित क्षेत्र में परिवर्तित करना। 20वीं सदी की शुरुआत में भारत का वन क्षेत्र ~ 30%; सदी के अंत तक <19.4 % (राष्ट्रीय वन नीति target = 33 %) के विरुद्ध)।',
            },
            {
              english: 'Causes — slash-and-burn agriculture (jhum), conversion to crop land, raw material for industries, urbanisation, fires, overgrazing, fuel-wood collection.',
        hindi: 'कारण-काटकर जलाओ कृषि (झूम), फसल भूमि का रूपांतरण, उद्योगों के लिए कच्चा माल, शहरीकरण, आग, अत्यधिक चराई, ईंधन-लकड़ी संग्रह।',
            },
            {
              english: 'Consequences — ↑ CO₂; loss of biodiversity; disturbed hydrologic cycle; soil erosion → desertification.',
        hindi: 'परिणाम - ↑ CO₂; जैव विविधता का नुकसान; अशांत जल विज्ञान चक्र; मृदा अपरदन → मरुस्थलीकरण। **पुनर्वनरोपण** — जंगल को पुनर्स्थापित करने की प्रक्रिया। सरकार की पहल: **स्थानीय समुदायों के साथ संयुक्त वन प्रबंधन (जेएफएम, 1980 का दशक)**।',
            },
            {
              english: '**Reforestation** — process of restoring a forest. Govt initiatives: **Joint Forest Management (JFM, 1980s)** with local communities.',
        hindi: '**पुनर्वनरोपण** - जंगल को पुनर्स्थापित करने की प्रक्रिया। सरकार की पहल: **स्थानीय समुदायों के साथ संयुक्त वन प्रबंधन (जेएफएम, 1980 का दशक)**।',
            },
            {
              english: '**Chipko movement** (1974, Garhwal Himalayas, Uttarakhand) — local women hugged trees to save them from contractors\' axes.',
        hindi: '**चिपको आंदोलन** (1974, गढ़वाल हिमालय, उत्तराखंड) - ठेकेदारों की कुल्हाड़ियों से बचाने के लिए स्थानीय महिलाएं पेड़ों से लिपट गईं। **अमृता देवी बिश्नोई वन्यजीव संरक्षण पुरस्कार** अमृता देवी बिश्नोई (1731, खेजड़ली, राजस्थान) की स्मृति में स्थापित किया गया - खेजड़ी के पेड़ों की रक्षा के लिए 363 अन्य लोगों के साथ जीवन का बलिदान दिया।',
            },
            {
              english: '**Amrita Devi Bishnoi Wildlife Protection Award** instituted in memory of Amrita Devi Bishnoi (1731, Khejarli, Rajasthan) — sacrificed life with 363 others to protect khejri trees.',
        hindi: '**अमृता देवी बिश्नोई वन्यजीव संरक्षण पुरस्कार** अमृता देवी बिश्नोई (1731, खेजड़ली, राजस्थान) की स्मृति में स्थापित किया गया - खेजड़ी के पेड़ों की रक्षा के लिए 363 अन्य लोगों के साथ जीवन का बलिदान दिया।',
            },
          ],
        },
      ],
    },
  ],
  keyFormulas: [
    {
      latex: '\\text{ESP removes > 99\\% of particulate matter}',
      desc: {
        english: '',
        hindi: 'ईएसपी >99\\% पार्टिकुलेट मैटर को हटा देता है',
      },
    },
    {
      latex: '\\text{Catalytic converter (Pt-Pd-Rh) needs unleaded petrol}',
      desc: {
        english: '',
        hindi: 'कैटेलिटिक कनवर्टर (Pt-Pd-Rh) को अनलेडेड पेट्रोल की आवश्यकता होती है',
      },
    },
    {
      latex: '\\text{Higher BOD} \\Rightarrow \\text{higher pollution}',
      desc: {
        english: '',
        hindi: 'जितना अधिक बीओडी उतना अधिक प्रदूषण',
      },
    },
    {
      latex: '\\text{Biomagnification (DDT): 0.003 ppb} \\rightarrow 25 \\text{ ppm in birds}',
      desc: {
        english: '',
        hindi: 'जैव आवर्धन (डीडीटी): पक्षियों में 0.003 पीपीबी 25 पीपीएम',
      },
    },
    {
      latex: '\\text{Greenhouse: CO}_2 60\\%, \\text{CH}_4 20\\%, \\text{CFC 14\\%, N}_2\\text{O 6\\%}',
      desc: {
        english: '',
        hindi: 'ग्रीनहाउस: CO 2 60\\%, CH 4 20\\%, CFC 14\\%, N 2O 6\\%',
      },
    },
    {
      latex: '\\text{1 Cl atom destroys} \\approx 10^5 \\text{ O}_3 \\text{ molecules (CFCs)}',
      desc: {
        english: '',
        hindi: '1 सीएल परमाणु 10 5 ओ 3 अणुओं (सीएफसी) को नष्ट कर देता है',
      },
    },
    {
      latex: '\\text{Ozone thickness in Dobson units (DU); Montreal Protocol 1987}',
      desc: {
        english: '',
        hindi: 'डॉब्सन इकाइयों (डीयू) में ओजोन की मोटाई; मॉन्ट्रियल प्रोटोकॉल 1987',
      },
    },
  ],
  pyqs: [
    {
      year: 2024,
      exam: 'NEET',
      tag: 'Pollution',
      problem: {
        english: 'Electrostatic precipitator removes:',
        hindi: 'इलेक्ट्रोस्टैटिक प्रीसिपिटेटर हटाता है:',
      },
      answer: {
        english: 'Particulate matter (>99 %)',
        hindi: 'पार्टिकुलेट मैटर (>99%)',
      },
      solution: {
        english: 'Charged particles attracted to grounded plates.',
        hindi: 'आवेशित कण जमी हुई प्लेटों की ओर आकर्षित होते हैं।',
      },
    },
    {
      year: 2023,
      exam: 'NEET',
      tag: 'Biomagnification',
      problem: {
        english: 'Eggshell thinning in birds is caused by biomagnification of:',
        hindi: 'पक्षियों में अंडे के छिलके का पतला होना किसके जैव आवर्धन के कारण होता है:',
      },
      answer: {
        english: 'DDT',
        hindi: 'डीडीटी',
      },
      solution: {
        english: 'Reduces calcium deposition; eggs break.',
        hindi: 'कैल्शियम जमाव को कम करता है; अंडे टूटते हैं.',
      },
    },
    {
      year: 2022,
      exam: 'NEET',
      tag: 'Greenhouse',
      problem: {
        english: 'Largest contributor to greenhouse gases is:',
        hindi: 'ग्रीनहाउस गैसों में सबसे बड़ा योगदानकर्ता है:',
      },
      answer: {
        english: 'CO₂ (~60 %)',
        hindi: 'CO₂ (~60 %)',
      },
      solution: {
        english: 'CH₄ 20 %, CFC 14 %, N₂O 6 %.',
        hindi: 'CH₄20%, CFC 14%, N₂O 6%।',
      },
    },
    {
      year: 2020,
      exam: 'NEET',
      tag: 'Ozone',
      problem: {
        english: 'Ozone layer depletion is mainly caused by:',
        hindi: 'ओजोन परत का क्षय मुख्यतः निम्न कारणों से होता है:',
      },
      answer: {
        english: 'CFCs (Chlorofluorocarbons)',
        hindi: 'सीएफसी (क्लोरोफ्लोरोकार्बन)',
      },
      solution: {
        english: 'Release Cl in stratosphere; Montreal Protocol controls them.',
        hindi: 'समताप मंडल में सीएल जारी करें; मॉन्ट्रियल प्रोटोकॉल इन्हें नियंत्रित करता है।',
      },
    },
    {
      year: 2018,
      exam: 'NEET',
      tag: 'Movement',
      problem: {
        english: 'Chipko movement was launched to:',
        hindi: 'चिपको आंदोलन किसके लिए शुरू किया गया था:',
      },
      answer: {
        english: 'Prevent felling of trees',
        hindi: 'पेड़ों की कटाई रोकें',
      },
      solution: {
        english: 'Garhwal Himalayas, 1974; women hugged trees.',
        hindi: 'गढ़वाल हिमालय, 1974; महिलाओं ने पेड़ों को गले लगाया. **बिग बैंग सिद्धांत** - ब्रह्मांड की उत्पत्ति ~**13.7 अरब वर्ष पहले** एक ही विस्फोट से हुई थी। आकाशगंगाएँ, तारे बने; पृथ्वी ~4.5 बाय। **जीवन की उत्पत्ति के सिद्धांत**:',
      },
    },
  ],
  next: {
    slug: 'living-world',
    title: 'The Living World',
  },
};

export default chapter;
